// pages/WebsiteLinks/AddWebsite.js
import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  Divider,
  useTheme,
  Stack,
} from "@mui/material";
import AddLinkIcon from "@mui/icons-material/AddLink";

export default function AddWebsite({ closeModal, refresh, handleRefresh, chatbotId, permission }) {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    document.title = "Add Website | KlonIT Web Application";
  }, []);

  const handleAddWebBtnClick = async () => {

    if (!inputValue.trim()) {
      setError("Error: Please type website link.");
      return;
    }


    setIsProcessing(true);
    try {
      const params = chatbotId ? { chatbot_id: chatbotId } : {};
      const response = await axiosInstance.post(
        `/add-website-link`,
        { website_link: inputValue },
        { params }
      );
      setInputValue("");
      setError(response.data.message);
      handleRefresh();
    } catch (error) {
      setError(`Error: ${error.response?.data?.message || error.message}`);
    }

    setIsProcessing(false);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 2,
        bgcolor: "background.paper",
        color: "text.primary",
        maxWidth: 600,
        mx: "auto",
      }}
    >
      <Typography variant="h5" fontWeight={700} gutterBottom    color="textPrimary">
        Add <strong>Website</strong> Links
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
        (Links should start with <strong>https://</strong> or <strong>www</strong>)
      </Typography>

      <Stack spacing={2}>
        <TextField
          fullWidth
          label="Website Link"
          variant="outlined"
          size="medium"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          sx={{
            input: { color: "text.primary" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: theme.palette.divider,
              },
            },
          }}
        />

        {permission.canModify && (
          <Button
            variant="contained"
            startIcon={<AddLinkIcon />}
            onClick={handleAddWebBtnClick}
            disabled={isProcessing}
          >
            Add Website Link
          </Button>
        )}

        {error && (
          <Alert
            severity={error.includes("Error") ? "error" : "success"}
            sx={{ mt: 2 }}
          >
            {error}
          </Alert>
        )}
      </Stack>
    </Paper>
  );
}
